import { useTranslation } from "react-i18next";

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section id="hero" className="relative w-full min-h-[580px] md:min-h-[680px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20overhead%20flatlay%20composition%20featuring%20diverse%20fashion%20items%20shoes%20accessories%20bags%20and%20textiles%20scattered%20thoughtfully%20across%20a%20light%20cream%20textured%20canvas%20surface%2C%20soft%20diffused%20natural%20skylight%2C%20editorial%20magazine%20aesthetic%20with%20gentle%20shadow%20depth%2C%20warm%20ivory%20cream%20beige%20palette%2C%20sophisticated%20product%20arrangement%20with%20intentional%20negative%20space%20and%20organic%20flow&width=1600&height=900&seq=hero-bg-v2-main&orientation=landscape"
          alt="OOPBuy Spreadsheet product database"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/45"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-6 md:px-10 text-center py-16 md:py-20">
        <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-background-50/20 backdrop-blur-sm rounded-full border border-background-50/30 mb-6 md:mb-8">
          <span className="w-1.5 h-1.5 rounded-full bg-accent-400"></span>
          <span className="text-xs md:text-sm text-background-50/90 font-medium tracking-wide">UPDATED 2026 DATABASE</span>
        </div>

        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 leading-tight mb-4 md:mb-5">
          {t("hero.title")}
        </h1>

        <p className="font-heading text-xl md:text-2xl lg:text-3xl text-background-50/90 font-light italic mb-5 md:mb-6">
          {t("hero.subtitle")}
        </p>

        <p className="text-sm md:text-base text-background-50/80 max-w-2xl mx-auto leading-relaxed mb-8 md:mb-10">
          {t("hero.description")}
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-background-50 text-foreground-900 font-semibold rounded-full hover:bg-background-100 transition-all duration-300 whitespace-nowrap cursor-pointer text-sm md:text-base"
          >
            <i className="ri-external-link-line"></i>
            {t("hero.cta.primary")}
          </a>
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 border-2 border-background-50/80 text-background-50 font-semibold rounded-full hover:bg-background-50/15 transition-all duration-300 whitespace-nowrap cursor-pointer text-sm md:text-base"
          >
            <i className="ri-shopping-cart-line"></i>
            {t("hero.cta.secondary")}
          </a>
        </div>

        <p className="mt-8 text-xs md:text-sm text-background-50/60 max-w-xl mx-auto leading-relaxed">
          {t("hero.hook")}
        </p>
      </div>
    </section>
  );
}